// import { Button, List, ListItem, Typography } from "@mui/material";
// import { Box } from "@mui/system";
// import React from "react";
// import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
// import logo from "../assets/BigLogo.png";
// import EastIconArrow from "../assets/east.svg";
// import {
//   callRedirectionNo,
//   faceBookRedirection,
//   instagramRedirection,
//   mapRedirection,
//   youtubeRedirection,
//   GoogleSheetRedirection
// } from "../api/Redirection";
// import { useNavigate } from "react-router-dom";

// const SocialMediaBox = ({ label, backgroundColor, hoverColor, link }) => (
//   <Box
//     component={Button}
//     onClick={() => window.open(link, "_blank")}
//     sx={{
//       width: "100%",
//       height: { xs: "60px", md: "179px" },
//       backgroundColor,
//       display: "flex",
//       cursor: "pointer",
//       justifyContent: "center",
//       alignItems: "center",
//       borderBottom: "1px solid rgba(229, 211, 195, 1)",
//       borderLeft: "1px solid rgba(229, 211, 195, 1)",
//       transition: "background-color 0.3s ease",
//       "&:hover": {
//         backgroundColor: hoverColor,
//         "& img": {
//           transform: "rotate(0deg)", // Rotates back to normal on hover
//         },
//       },
//     }}
//   >
//     <Typography
//       sx={{
//         fontFamily: "ZapfHumnst BT",
//         fontSize: { xs: "14px", md: "24px" },
//         lineHeight: { xs: "17.33px", md: "37.13px" },
//         fontWeight: 400,
//         display: "flex",
//         alignItems: "center",
//         letterSpacing: "0.05em",
//         color: "#181818",
//         textTransform: "none",
//         "& img": {
//           width: "25px",
//           height: "25px",
//           transform: "rotate(-50deg)", // Default rotation
//           transition: "transform 0.3s ease", // Smooth transition
//         },
//       }}
//     >
//       {label}
//       <img src={EastIconArrow} alt="east" />
//     </Typography>
//   </Box>


// );
// export const ContactFooter = () => {
//   return (
//     <>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           width: "100%",
//         }}
//       >
//         <SocialMediaBox
//           link={faceBookRedirection}
//           label="Facebook"
//           backgroundColor="#FFFFFF"
//           hoverColor="rgba(220, 190, 160, 1)"
//         />
//         <SocialMediaBox
//           link={instagramRedirection}
//           label="Instagram"
//           backgroundColor="#FFFFFF"
//           hoverColor="rgba(220, 190, 160, 1)"
//         />
//         <SocialMediaBox
//           link={youtubeRedirection}
//           label="YouTube"
//           backgroundColor="#FFFFFF"
//           hoverColor="rgba(220, 190, 160, 1)"
//         />
//       </Box>
//     </>
//   );
// };
// const FooterInfo = [
//   {
//     src: logo,
//   },
//   {
//     name: "Address",
//     items: [
//             "THE FARM STORIES", "Near Sai baba temple,", "Seegekote village,", "Shivanahalli, Kanakpura,", "Karnataka - 562117",
//           ],
//     action: "Get Direction",
//     do: "map",
//   },
//   {
//     name: "Contacts",
//     items: [
//       "+91 8971713741",
//       "+91 9620232209",
//       "info@farmstories.in",
//     ],
//     action: "Call Now",
//     do: "call",
//   },
//   {
//     name: "Links",
//     items: [
//       // { label: "Decor", do: "navigate", path: "/decor" },
//       { label: "Tariff", do: "navigate", path: "/tariff" },
//       { label: "Check Availability", do: "google-sheet" },
//       // { label: " View Gallery", do: "navigate", path: "/gallery" },
//       "",
//     ],
//     action: "View Gallery",
//     do: "navigate",
//   },
// ];


// const Footer = () => {
//   const navigate = useNavigate();

//   const handleGoogleSheetClick = () => {
//     window.open(GoogleSheetRedirection, "_blank"); // Updated to use GoogleSheetRedirection
//   };
  
//   return (
//     <Box
//       sx={{
//         width: "100%",
//         height: "auto",
//       }}
//     >
//       <Box display={"flex"} justifyContent={"space-between"}>
//         <SocialMediaBox
//           link={faceBookRedirection}
//           label="Facebook"
//           backgroundColor="#FBF7F3"
//           hoverColor="#F0E2D6"
//         />
//         <SocialMediaBox
//           link={instagramRedirection}
//           label="Instagram"
//           backgroundColor="#FBF7F3"
//           hoverColor="#F0E2D6"
//         />
//         <SocialMediaBox
//           link={youtubeRedirection}
//           label="YouTube"
//           backgroundColor="#FBF7F3"
//           hoverColor="#F0E2D6"
//         />
//       </Box>
//       <Box
//         width={"100%"}
//         padding={"0 30px"}
//         pb={{ xs: 5, md: 10 }}
//         pt={{ xs: 5, md: 10 }}
//         display={"flex"}
//         justifyItems={"center"}
//         justifyContent={"center"}
//         boxSizing={"border-box"}
//         backgroundColor="#FBF7F3"
//       >
//         <Box
//           display={"flex"}
//           maxWidth={"1440px"}
//           gap={{ xs: 1, sm: 12 }}
//           justifyContent={"space-between"}
//           alignItems={"flex-start"}
//           flexWrap={"wrap"}
//           boxSizing={"border-box"}
//         // gap={{ xs:2, sm: 20 }}
//         >
//           {FooterInfo.map((section, index) => (
//             <Box key={index}>
//               {section.src && (
//                 <Box
//                   width={{ xs: "93px", md: "186px" }}
//                   height={{ xs: "88px", md: "176px" }}
//                 >
//                   <img
//                     width={"100%"}
//                     height={"100%"}
//                     src={section.src}
//                     alt=""
//                   />
//                 </Box>
//               )}

//               <Box
//                 display={"flex"}
//                 flexDirection={"column"}
//                 width={"210px"}
//                 justifyContent={"flex-start"}
//                 gap={{ xs: 1, sm: 3 }}
//               >
//                 <Box display={"flex"} width={"100%"} flexDirection={"column"}>
//                   <Typography
//                     sx={{
//                       fontFamily: "ZapfHumnst BT",
//                       fontSize: { xs: "14px", md: "18px" },
//                       fontWeight: 400,
//                       lineHeight: { xs: "17.33px", md: "24.76px" },
//                       color: "#181818",
//                       marginBottom: "10px",
//                     }}
//                   >
//                     {section.name}
//                   </Typography>
//                   <List>
//                     {section.items &&
//                       section.items.map((item, idx) => (
//                         <ListItem key={idx} sx={{ p: 0 }}>
//                           <Typography
//                             lineHeight={section.name === "Address" ? "36px" : "32px"}
//                             sx={{
//                               fontFamily: "Sora",
//                               fontSize: { xs: "10px", md: "14px" },
//                               fontWeight: 300,
//                               lineHeight: { xs: "18px", md: "32px" },
//                               color: "#886F58",
//                               cursor: item.do ? "pointer" : "default",
//                             }}
//                             onClick={() => {
//                               if (item.do === "navigate") {
//                                 navigate(item.path);
//                                 window.scrollTo(0, 0);
//                               } else if (item.do === "google-sheet") { // Updated condition
//                                 handleGoogleSheetClick();
//                               }
//                             }}
//                           >
//                             {item.label || item}
//                           </Typography>
//                         </ListItem>
//                       ))}
//                   </List>
//                 </Box>
//                 {section.action && (
//                   <Button
//                     onClick={() => {
//                       if (section.do === "map") {
//                         window.open(mapRedirection);
//                       } else if (section.do === "call") {
//                         window.open(`tel:${callRedirectionNo}`);
//                       } else if (section.do === "navigate") {
//                         navigate("/gallery");
//                         window.scrollTo(0, 0);
//                       }
//                     }}
//                     endIcon={<ArrowOutwardIcon fontSize="small" />}
//                     variant="text"
//                     disableElevation
//                     disableRipple
//                     sx={{
//                       textAlign: "left",
//                       width: "153px",
//                       height: "32px",
//                       pl: 0,
//                       display: "flex",
//                       justifyContent: "start",
//                       fontFamily: "Sora",
//                       lineHeight: { xs: "36px", md: "36px" },
//                       fontSize: { xs: "11px", md: "14px" },
//                       color: "#B8772A",
//                       textTransform: "capitalize",
//                       fontWeight: 500,
//                       "&:hover": {
//                         backgroundColor: "transparent",
//                       },
//                     }}
//                   >
//                     {section.action}
//                   </Button>
//                 )}

//               </Box>
//             </Box>
//           ))}
//         </Box>
//       </Box>
//       <Box
//         display={"flex"}
//         pb={1}
//         sx={{
//           background: "#FBF7F3",
//           borderTop: "1px solid #EDE0D4",
//           height: "50px",
//           alignItems: "center",
//         }}
//       >
//         <Typography
//           sx={{
//             fontFamily: "ZapfHumnst BT",
//             fontSize: "11px",
//             fontWeight: 300,
//             textTransform: "capitalize",
//             color: "#886F58",
//             justifyContent: "center",
//             boxSizing: "border-Box",
//             width: "50%",
//             textAlign: "center",
//           }}
//         >
//           All Rights Reserved
//         </Typography>
//         <Typography
//           sx={{
//             fontFamily: "ZapfHumnst BT",
//             fontSize: "11px",
//             fontWeight: 300,
//             textTransform: "capitalize",
//             color: "#886F58",
//             justifyContent: "center",
//             boxSizing: "border-Box",
//             width: "50%",
//             textAlign: "center",
//           }}
//         >
//           MADE IN BENGALURU
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// export default Footer;

import { Button, List, ListItem, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import logo from "../assets/BigLogo.png";
import EastIconArrow from "../assets/east.svg";
import {
  callRedirectionNo,
  faceBookRedirection,
  instagramRedirection,
  mapRedirection,
  youtubeRedirection,
  GoogleSheetRedirection,
} from "../api/Redirection";
import { useNavigate } from "react-router-dom";

const SocialMediaBox = ({ label, backgroundColor, hoverColor, link }) => (
  <Box
    component={Button}
    onClick={() => window.open(link, "_blank")}
    sx={{
      width: "100%",
      height: { xs: "60px", md: "179px" },
      backgroundColor,
      display: "flex",
      cursor: "pointer",
      justifyContent: "center",
      alignItems: "center",
      borderBottom: "1px solid rgba(229, 211, 195, 1)",
      borderLeft: "1px solid rgba(229, 211, 195, 1)",
      transition: "background-color 0.3s ease",
      "&:hover": {
        backgroundColor: hoverColor,
        "& img": {
          transform: "rotate(0deg)",
        },
      },
    }}
  >
    <Typography
      sx={{
        fontFamily: "ZapfHumnst BT",
        fontSize: { xs: "14px", md: "24px" },
        lineHeight: { xs: "17.33px", md: "37.13px" },
        fontWeight: 400,
        display: "flex",
        alignItems: "center",
        letterSpacing: "0.05em",
        color: "#181818",
        textTransform: "none",
        "& img": {
          width: "25px",
          height: "25px",
          transform: "rotate(-50deg)",
          transition: "transform 0.3s ease",
        },
      }}
    >
      {label}
      <img src={EastIconArrow} alt="east" />
    </Typography>
  </Box>
);

export const ContactFooter = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <SocialMediaBox
          link={faceBookRedirection}
          label="Facebook"
          backgroundColor="#FFFFFF"
          hoverColor="rgba(220, 190, 160, 1)"
        />
        <SocialMediaBox
          link={instagramRedirection}
          label="Instagram"
          backgroundColor="#FFFFFF"
          hoverColor="rgba(220, 190, 160, 1)"
        />
        <SocialMediaBox
          link={youtubeRedirection}
          label="YouTube"
          backgroundColor="#FFFFFF"
          hoverColor="rgba(220, 190, 160, 1)"
        />
      </Box>
    </>
  );
};

const FooterInfo = [
  {
    src: logo,
  },
  {
    name: "Address",
    items: [
      "THE FARM STORIES",
      "Near Sai baba temple,",
      "Seegekote village,",
      "Shivanahalli, Kanakpura,",
      "Karnataka - 562117",
    ],
    action: "Get Direction",
    do: "map",
  },
  {
    name: "Contacts",
    items: ["+91 8971713741", "+91 9620232209", "enquiry@thefarmstories.in"],
    action: "Call Now",
    do: "call",
  },
  {
    name: "Links",
    items: [
      { label: "Tariff", do: "navigate", path: "/tariff" },
      { label: "Check Availability", do: "google-sheet" },
      "",
    ],
    action: "View Gallery",
    do: "navigate",
  },
];

const Footer = () => {
  const navigate = useNavigate();

  const handleGoogleSheetClick = () => {
    window.open(GoogleSheetRedirection, "_blank");
  };

  return (
    <Box sx={{ width: "100%", height: "auto" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
        <SocialMediaBox
          link={faceBookRedirection}
          label="Facebook"
          backgroundColor="#FBF7F3"
          hoverColor="#F0E2D6"
        />
        <SocialMediaBox
          link={instagramRedirection}
          label="Instagram"
          backgroundColor="#FBF7F3"
          hoverColor="#F0E2D6"
        />
        <SocialMediaBox
          link={youtubeRedirection}
          label="YouTube"
          backgroundColor="#FBF7F3"
          hoverColor="#F0E2D6"
        />
      </Box>

      <Box
        width="100%"
        padding="0 30px"
        pb={{ xs: 5, md: 10 }}
        pt={{ xs: 5, md: 10 }}
        display="flex"
        justifyItems="center"
        justifyContent="center"
        boxSizing="border-box"
        backgroundColor="#FBF7F3"
      >
        <Box
          display="flex"
          maxWidth="1440px"
          gap={{ xs: 1, sm: 12 }}
          justifyContent="space-between"
          alignItems="stretch"
          flexWrap="wrap"
          boxSizing="border-box"
        >
          {FooterInfo.map((section, index) => (
            <Box
              key={index}
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              width="210px"
              boxSizing="border-box"
              sx={{ flexGrow: 1 }}
            >
              {section.src && (
                <Box
                  width={{ xs: "93px", md: "186px" }}
                  height={{ xs: "88px", md: "176px" }}
                  mb={2}
                >
                  <img width="100%" height="100%" src={section.src} alt="logo" />
                </Box>
              )}

              {!section.src && (
                <Box display="flex" flexDirection="column" height="100%" justifyContent="space-between">
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "ZapfHumnst BT",
                        fontSize: { xs: "14px", md: "18px" },
                        fontWeight: 400,
                        lineHeight: { xs: "17.33px", md: "24.76px" },
                        color: "#181818",
                        marginBottom: "10px",
                      }}
                    >
                      {section.name}
                    </Typography>
                    <List>
                      {section.items &&
                        section.items.map((item, idx) => (
                          <ListItem key={idx} sx={{ p: 0 }}>
                            <Typography
                              lineHeight={section.name === "Address" ? "36px" : "32px"}
                              sx={{
                                fontFamily: "Sora",
                                fontSize: { xs: "10px", md: "14px" },
                                fontWeight: 300,
                                lineHeight: { xs: "18px", md: "32px" },
                                color: "#886F58",
                                cursor: item.do ? "pointer" : "default",
                              }}
                              onClick={() => {
                                if (item.do === "navigate") {
                                  navigate(item.path);
                                  window.scrollTo(0, 0);
                                } else if (item.do === "google-sheet") {
                                  handleGoogleSheetClick();
                                }
                              }}
                            >
                              {item.label || item}
                            </Typography>
                          </ListItem>
                        ))}
                    </List>
                  </Box>

                  {section.action && (
                    <Button
                      onClick={() => {
                        if (section.do === "map") {
                          window.open(mapRedirection);
                        } else if (section.do === "call") {
                          window.open(`tel:${callRedirectionNo}`);
                        } else if (section.do === "navigate") {
                          navigate("/gallery");
                          window.scrollTo(0, 0);
                        }
                      }}
                      endIcon={<ArrowOutwardIcon fontSize="small" />}
                      variant="text"
                      disableElevation
                      disableRipple
                      sx={{
                        textAlign: "left",
                        width: "fit-content",
                        pl: 0,
                        display: "flex",
                        justifyContent: "start",
                        fontFamily: "Sora",
                        lineHeight: { xs: "36px", md: "36px" },
                        fontSize: { xs: "11px", md: "14px" },
                        color: "#B8772A",
                        textTransform: "capitalize",
                        fontWeight: 500,
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                    >
                      {section.action}
                    </Button>
                  )}
                </Box>
              )}
            </Box>
          ))}
        </Box>
      </Box>

      <Box
        display="flex"
        pb={1}
        sx={{
          background: "#FBF7F3",
          borderTop: "1px solid #EDE0D4",
          height: "50px",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontFamily: "ZapfHumnst BT",
            fontSize: "11px",
            fontWeight: 300,
            textTransform: "capitalize",
            color: "#886F58",
            justifyContent: "center",
            boxSizing: "border-box",
            width: "50%",
            textAlign: "center",
          }}
        >
          All Rights Reserved
        </Typography>
        <Typography
          sx={{
            fontFamily: "ZapfHumnst BT",
            fontSize: "11px",
            fontWeight: 300,
            textTransform: "capitalize",
            color: "#886F58",
            justifyContent: "center",
            boxSizing: "border-box",
            width: "50%",
            textAlign: "center",
          }}
        >
          MADE IN BENGALURU
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
